module.exports = __webpack_public_path__ + "img/oi.ef5ec8ff.jpg";